export default "__VITE_ASSET__BXqDQC6M__"